export const LOADING_STATES = Object.freeze({
    LOADING: "loading",
    SUCCESS: "success",
    FAILED: "failed"
});
